import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RiveModule } from 'ng-rive';
import { Observable, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  standalone: true,
  imports: [CommonModule, RiveModule],
})
export class AuthorizeComponent {
  theme$: Observable<string>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private themeService: ThemeService
  ) {
    this.theme$ = this.themeService.theme$;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      const { encoded: redirectParam, decoded: redirectUrl } = SharedService.decodeAndValidateRedirectUrl(params['redirect'] ?? params['url']);
      const refreshToken = this.authService.getRefreshToken();

      if (!refreshToken) {
        this.authService.redirectToLogin(redirectParam);
        return;
      }

      this.authService
        .refreshSession()
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            const newAccessToken = response.data.access_token;
            if (!newAccessToken) {
              this.authService.clearSessionAndRedirectToLogin(redirectParam);
              return;
            }
            this.authService.setAccessToken(newAccessToken);
            window.location.href = redirectUrl ?? environment.sandbox_console_host;
          },
          error: () => {
            this.authService.clearSessionAndRedirectToLogin(redirectParam);
          },
        });
    });
  }

}
